import { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { RxCross2 } from 'react-icons/rx';
import NewInput from 'app/components/NewInput';
import Button from 'app/components/button';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import FilterModel from 'app/components/FilterModel';
import Dropdown from 'app/components/Dropdown';
import { CustomerManagementHeader } from 'app/constants/table-header-constants';
import useCustomerManagement from './useCustomerManagement';

const STATUS_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Unblocked', value: '1' },
  { label: 'Blocked', value: '3' },
];

const CustomerManagement = () => {
  const {
    fetchCustomerData,
    handleStatusChange,
    handleNew,
    totalNumber,
    filteredData,
    sectionObj,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    handledDeleteStatusChange,
    handlemodelvalues,
    passwordmodelOpen,
    setPasswordmodelOpen,
    passwordVal,
    setPasswordVal,
    isFilterOpen,
    setIsFilterOpen,
    isFiltering,
    values,
    setValues,
    appliedFilters,
    handleSubmit,
    handleFilterCancel,
    resetfilter,
  } = useCustomerManagement();

  const closeModal = () => {
    setPasswordmodelOpen(false);
    setPasswordVal('');
  };

  const modalContent = useMemo(
    () => (
      <Modal
        size='sm'
        show={passwordmodelOpen}
        onHide={closeModal}
        aria-labelledby='password-popup'
        centered
      >
        <div className='cursor-pointer'>
          <span className='close-icon' onClick={closeModal}>
            <RxCross2 />
          </span>
        </div>
        <Modal.Body className='text-center d-flex justify-content-around mt-5'>
          <div className='modal-image-form'>
            <NewInput
              label='Password*'
              type='text'
              placeholder='Enter Password'
              value={passwordVal}
              onChange={(e) => setPasswordVal(e.target.value)}
            />
            <Button
              className='mt1 button ms-2'
              onClick={handlemodelvalues}
              variant='Submit'
              name='Submit'
              isDisabled={!passwordVal}
            />
          </div>
        </Modal.Body>
      </Modal>
    ),
    [passwordmodelOpen, handlemodelvalues, passwordVal]
  );

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={CustomerManagementHeader}
          data={filteredData}
          fetchData={fetchCustomerData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          handleNew={handleNew}
          handleStatusChange={handleStatusChange}
          pageLoading={pageLoading}
          handledDeleteStatusChange={handledDeleteStatusChange}
          isFiltering={isFiltering}
          values={appliedFilters}
        />

        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            resetfilter={resetfilter}
          >
            <div className='offcanvas-item'>
              <Dropdown
                id='status'
                label='Status'
                name='status'
                options={STATUS_OPTIONS}
                placeholder='All'
                value={values.status}
                handleChange={(e) =>
                  setValues({ ...values, status: e.target.value })
                }
              />
            </div>

            <div className='offcanvas-item'>
              <label>Last Active Date</label>
              <input
                type='date'
                value={values.lastActiveDate}
                onChange={(e) =>
                  setValues({ ...values, lastActiveDate: e.target.value })
                }
              />
            </div>
          </FilterModel>
        )}
      </div>
      {modalContent}
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default CustomerManagement;
